export const CATEGORIES = [
  'Appetizers',
  'Main Course',
  'Desserts',
  'Sauces',
  'Stocks',
  'Pastry',
  'Salads',
  'Soups',
  'Beverages',
  'Sides',
];

export const CUISINES = [
  'American',
  'Italian',
  'French',
  'Asian',
  'Mediterranean',
  'Mexican',
  'Indian',
  'Japanese',
  'Thai',
  'Other',
];

export const UNITS = [
  'g',
  'kg',
  'ml',
  'L',
  'oz',
  'lb',
  'cup',
  'tbsp',
  'tsp',
  'piece',
  'bunch',
  'clove',
  'slice',
  'pinch',
];

export const YIELD_UNITS = ['portions', 'servings', 'kg', 'liters', 'pieces'];

export const ALLERGENS = [
  {
    value: 'milk',
    label: 'Milk' 
  },
  {
    value: 'eggs',
    label: 'Eggs' 
  },
  {
    value: 'fish',
    label: 'Fish' 
  },
  {
    value: 'shellfish',
    label: 'Shellfish' 
  },
  {
    value: 'tree-nuts',
    label: 'Tree Nuts' 
  },
  {
    value: 'peanuts',
    label: 'Peanuts' 
  },
  {
    value: 'wheat',
    label: 'Wheat' 
  },
  {
    value: 'soybeans',
    label: 'Soybeans' 
  },
  {
    value: 'sesame',
    label: 'Sesame' 
  },
];

export const DIETARY_FLAGS = [
  {
    value: 'vegan',
    label: 'Vegan' 
  },
  {
    value: 'vegetarian',
    label: 'Vegetarian' 
  },
  {
    value: 'gluten-free',
    label: 'Gluten-Free' 
  },
  {
    value: 'dairy-free',
    label: 'Dairy-Free' 
  },
  {
    value: 'halal',
    label: 'Halal' 
  },
  {
    value: 'kosher',
    label: 'Kosher' 
  },
];

export const DIFFICULTY_OPTIONS = [
  {
    value: 'easy',
    label: 'Easy',
    color: 'bg-green-100 text-green-800' 
  },
  {
    value: 'medium',
    label: 'Medium',
    color: 'bg-amber-100 text-amber-800' 
  },
  {
    value: 'hard',
    label: 'Hard',
    color: 'bg-red-100 text-red-800' 
  },
];
